<template>
    <CFooter :fixed="false">
        <div>
            <b>MDL</b>
            <span class="ml-1">&copy; {{new Date().getFullYear()}}</span>
        </div>
        <div class="ml-auto">
            <span class="mr-1">Powered by</span>
            <a href="https://www.mfu.ac.th" target="_blank">Mae Fah Luang University</a>
        </div>
    </CFooter>
</template>

<script>
    export default {
        name: 'TheAdminFooter'
    }
</script>
